export default "__VITE_ASSET___7bHFGib__"